import React, { FC } from 'react';
import { useDispatch } from 'react-redux';
import {
  Item,
  StyledListItem,
  StyledListItemText,
  StyledCollapse,
} from 'containers/AppContainer/SideBar/style';
import {
  IconWrapper,
  StyledSubListItem,
  Stick,
} from 'containers/AppContainer/SideBar/style';
import { List, ListItemIcon } from '@material-ui/core';
import HomeIcon from 'components/SahamIcons/HomeIcon';
import FeeNoteIcon from 'components/SahamIcons/FeeNoteIcon';
import SettingIcon from 'components/SahamIcons/SettingIcon';
import { translate } from 'containers/services/translate';
import ArrowRightIcon from 'components/SahamIcons/ArrowRightIcon';
import ArrowDownIcon from 'components/SahamIcons/ArrowDownIcon';
import messages from 'containers/AppContainer/messages';
import { history } from 'store';
import { PAGES } from 'routes';
import { IntlShape, injectIntl } from 'react-intl';
import MissionIcon from 'components/SahamIcons/MissionIcon';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import { requestOpenLockClaimDialog } from 'containers/AppContainer/actions';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import DraftFilesIcon from 'components/SahamIcons/DraftFilesIcon';

const selectedItem = (paths: string[]) => {
  return paths.some(path => path === history.location.pathname);
};

interface CourtManagerMenuProps {
  intl: IntlShape;
  isManager?: boolean;
  pushToAndReset: Function;
  isMenuOpen: boolean;
}

const CourtManagerMenu: FC<CourtManagerMenuProps> = (props): JSX.Element => {
  const dispatch = useDispatch();
  const [subListOpen, setSubListOpen] = React.useState(false);

  const toggleSubListOpen = () => {
    setSubListOpen(!subListOpen);
  };

  const handleOpenUnlockClaimDialog = () => {
    dispatch(requestOpenLockClaimDialog(true));
  };
  const { pushToAndReset, isMenuOpen } = props;
  return (
    <List>
      <Item>
        <StyledListItem
          open={isMenuOpen}
          button
          selected={selectedItem([PAGES.COURT_MANAGER_HOME])}
          onClick={pushToAndReset(PAGES.COURT_MANAGER_HOME)}
        >
          <ListItemIcon>
            <HomeIcon isActivated />
          </ListItemIcon>
          {isMenuOpen && (
            <StyledListItemText open={isMenuOpen}>
              <span className="menuItemText">
                {translate(messages.sideBarHomeTitle, props)}
              </span>
            </StyledListItemText>
          )}
        </StyledListItem>
      </Item>
      {userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER) && (
        <>
          {!featureService.hasFeature(FEATURES.ATTRIBUTION_INBOXES_MANAGER) && (
            <Item>
              <StyledListItem
                open={isMenuOpen}
                button
                selected={selectedItem([PAGES.COURT_MANAGER_ASSIGNED_CLAIM])}
                onClick={pushToAndReset(PAGES.COURT_MANAGER_ASSIGNED_CLAIM)}
              >
                <ListItemIcon>
                  <MissionIcon />
                </ListItemIcon>
                {isMenuOpen && (
                  <StyledListItemText open={isMenuOpen}>
                    <span className="menuItemText">
                      {translate(messages.sideBarAffectedClaim, props)}
                    </span>
                  </StyledListItemText>
                )}
              </StyledListItem>
            </Item>
          )}
          <Item>
            <StyledListItem
              open={isMenuOpen}
              button
              selected={selectedItem([PAGES.MANAGER_FEE_NOTE])}
              onClick={pushToAndReset(PAGES.MANAGER_FEE_NOTE)}
            >
              <ListItemIcon>
                <FeeNoteIcon />
              </ListItemIcon>
              {isMenuOpen && (
                <>
                  <StyledListItemText open={isMenuOpen}>
                    <span className="menuItemText">
                      {translate(messages.sideBarFeeNote, props)}
                    </span>
                  </StyledListItemText>
                </>
              )}
            </StyledListItem>
          </Item>

          {featureService.hasFeature(FEATURES.ATTRIBUTION_INBOXES_MANAGER) && (
            <Item>
              <StyledListItem
                open={isMenuOpen}
                button
                selected={selectedItem([
                  PAGES.MANAGER_PENDING_TREATEMENT_CLAIMS,
                ])}
                onClick={pushToAndReset(
                  PAGES.MANAGER_PENDING_TREATEMENT_CLAIMS,
                )}
              >
                <ListItemIcon>
                  <FeeNoteIcon />
                </ListItemIcon>
                {isMenuOpen && (
                  <>
                    <StyledListItemText open={isMenuOpen}>
                      <span className="menuItemText">
                        {translate(messages.pendingTreatementClaims, props)}
                      </span>
                    </StyledListItemText>
                  </>
                )}
              </StyledListItem>
            </Item>
          )}
        </>
      )}
      {!userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER) && (
        <>
          <Item>
            <StyledListItem
              open={isMenuOpen}
              button
              selected={selectedItem([
                PAGES.COURT_MONITORING_MANAGER_ASSINGED_EXPERTISE,
              ])}
              onClick={pushToAndReset(
                PAGES.COURT_MONITORING_MANAGER_ASSINGED_EXPERTISE,
              )}
            >
              <ListItemIcon>
                <MissionIcon />
              </ListItemIcon>
              {isMenuOpen && (
                <>
                  <StyledListItemText open={isMenuOpen}>
                    <span className="menuItemText">
                      {translate(messages.sideBarLawyerAssignment, props)}
                    </span>
                  </StyledListItemText>
                </>
              )}
            </StyledListItem>
          </Item>
          {featureService.hasFeature(FEATURES.COURT_CALENDAR) && (
            <Item>
              <StyledListItem
                open={isMenuOpen}
                button
                selected={selectedItem([
                  PAGES.COURT_MONITORING_PROVISIONAL_CLAIMS,
                ])}
                onClick={pushToAndReset(
                  PAGES.COURT_MONITORING_PROVISIONAL_CLAIMS,
                )}
              >
                <ListItemIcon>
                  <DraftFilesIcon />
                </ListItemIcon>
                {isMenuOpen && (
                  <>
                    <StyledListItemText open={isMenuOpen}>
                      <span className="menuItemText">
                        {translate(
                          messages.sideBarCourtMonitoringProvisionalClaims,
                          props,
                        )}
                      </span>
                    </StyledListItemText>
                  </>
                )}
              </StyledListItem>
            </Item>
          )}
        </>
      )}
      {userPrivileges.userHasPrivilege(PRIVILEGES.ISMANAGER) &&
        featureService.hasFeature(FEATURES.ADMINISTRATION_MANAGER) && (
          <>
            <Item>
              <StyledListItem
                data-testid="sub-menu"
                open={isMenuOpen}
                button
                onClick={toggleSubListOpen}
              >
                <ListItemIcon>
                  <SettingIcon />
                </ListItemIcon>
                {isMenuOpen && (
                  <StyledListItemText open={isMenuOpen}>
                    <span className="menuItemText">
                      {translate(messages.sideBarAdministration, props)}
                    </span>
                  </StyledListItemText>
                )}
                {isMenuOpen ? (
                  subListOpen ? (
                    <IconWrapper>
                      <ArrowDownIcon />
                    </IconWrapper>
                  ) : (
                    <IconWrapper>
                      <ArrowRightIcon />
                    </IconWrapper>
                  )
                ) : null}
              </StyledListItem>
            </Item>

            <StyledCollapse
              in={subListOpen && isMenuOpen}
              timeout="auto"
              unmountOnExit
            >
              <Stick />
              <List component="div" disablePadding>
                {featureService.hasFeature(FEATURES.MANAGER_LOCK_CLAIM) && (
                  <Item>
                    <StyledSubListItem
                      open={isMenuOpen}
                      button
                      onClick={handleOpenUnlockClaimDialog}
                    >
                      {isMenuOpen && (
                        <StyledListItemText open={isMenuOpen}>
                          <span className="menuItemText">
                            {translate(messages.unlockClaim, props)}
                          </span>
                        </StyledListItemText>
                      )}
                    </StyledSubListItem>
                  </Item>
                )}
                {featureService.hasFeature(
                  FEATURES.ATTRIBUTION_INBOXES_MANAGER,
                ) && (
                  <Item>
                    <StyledSubListItem
                      open={isMenuOpen}
                      button
                      onClick={pushToAndReset(
                        PAGES.ATTRIBUTION_OPENING_MANAGER_PAGE,
                      )}
                    >
                      {isMenuOpen && (
                        <StyledListItemText open={isMenuOpen}>
                          <span className="menuItemText">
                            {translate(messages.attributionOpeningTitle, props)}
                          </span>
                        </StyledListItemText>
                      )}
                    </StyledSubListItem>
                  </Item>
                )}
                {featureService.hasFeature(
                  FEATURES.ATTRIBUTION_INBOXES_MANAGER,
                ) && (
                  <Item>
                    <StyledSubListItem
                      open={isMenuOpen}
                      button
                      onClick={pushToAndReset(
                        PAGES.ATTRIBUTION_JUDICIARY_MANAGER_PAGE,
                      )}
                    >
                      {isMenuOpen && (
                        <StyledListItemText open={isMenuOpen}>
                          <span className="menuItemText">
                            {translate(
                              messages.attributionJudiciaryTitle,
                              props,
                            )}
                          </span>
                        </StyledListItemText>
                      )}
                    </StyledSubListItem>
                  </Item>
                )}
                {featureService.hasFeature(
                  FEATURES.ATTRIBUTION_INBOXES_TRANSACTION_MANAGER,
                ) && (
                  <Item>
                    <StyledSubListItem
                      open={isMenuOpen}
                      button
                      onClick={pushToAndReset(
                        PAGES.ATTRIBUTION_TRANSACTION_MANAGER_PAGE,
                      )}
                    >
                      {isMenuOpen && (
                        <StyledListItemText open={isMenuOpen}>
                          <span className="menuItemText">
                            {translate(
                              messages.attributionTransactionTitle,
                              props,
                            )}
                          </span>
                        </StyledListItemText>
                      )}
                    </StyledSubListItem>
                  </Item>
                )}
                {featureService.hasFeature(FEATURES.PLATFORM_MANAGER) && (
                  <Item>
                    <StyledSubListItem
                      open={isMenuOpen}
                      button
                      onClick={pushToAndReset(
                        PAGES.PLATFORM_MANAGER_MANAGEMENT,
                      )}
                    >
                      {isMenuOpen && (
                        <StyledListItemText open={isMenuOpen}>
                          <span className="menuItemText">
                            {translate(messages.platformManagerTitle, props)}
                          </span>
                        </StyledListItemText>
                      )}
                    </StyledSubListItem>
                  </Item>
                )}
                {featureService.hasFeature(
                  FEATURES.PLATFORM_MANAGER_INTERVENANT,
                ) && (
                  <Item>
                    <StyledSubListItem
                      open={isMenuOpen}
                      button
                      onClick={pushToAndReset(
                        PAGES.PLATFORM_MANAGER_MANAGEMENT_INTERVENANT,
                      )}
                    >
                      {isMenuOpen && (
                        <StyledListItemText open={isMenuOpen}>
                          <span className="menuItemText">
                            {translate(
                              messages.platformManagerIntervenantTitle,
                              props,
                            )}
                          </span>
                        </StyledListItemText>
                      )}
                    </StyledSubListItem>
                  </Item>
                )}
              </List>
            </StyledCollapse>
          </>
        )}
    </List>
  );
};

export default injectIntl(CourtManagerMenu);
